import { useMutation } from "@tanstack/react-query";
import { manInfApi, manListApi } from "components/api/member";
import { PAGE_ID_MEMBER_MANAGER } from "components/constent";
import { apifield } from "components/utils/comm";
import { initialPageNav } from "components/utils/comm";
import { IPageNav } from "interface/index";
import { IManInf } from "interface/member";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import useListRowInfStroe from "store/listRowInf";
import usePageNoStore from "store/pageNo";

// 객실 예약취소 조회
type ISearch = {
  param: any;
};

export const useSearchList = ({ param }: ISearch) => {
  const { t } = useTranslation();

  const [rowData, setRowData] = useState<any[] | null>(null);
  const pageNavRef = useRef<IPageNav>(initialPageNav);

  const mutation = useMutation({
    mutationKey: ["member-manager--search"],
    mutationFn: manListApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          const pageNav = data.pageNav;
          pageNavRef.current = data.pageNav;
          const rmResvCnls = data.rmResvCnlList.map(
            (man: IManInf, index: number) => {
              return {
                ...man,
                No: (pageNav.pageNo - 1) * pageNav.pageRows + index + 1,
                uYn:
                  man.soYn === "Y"
                    ? t("user_withdrawn")
                    : man.lckYn === "Y"
                    ? t("user_dormant")
                    : man.joiAprYn === "Y"
                    ? t("user_approval") //approval
                    : t("user_request"), //request
                detail: t("txt_detail_cmm"), //detail
                modify: t("txt_edit_cmm"), //edit
              };
            }
          );
          setRowData(rmResvCnls);
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });

  useEffect(() => {
    if (param) {
      mutation.mutate(param);
    }
  }, [param]);

  // NextPage
  const pageNo = usePageNoStore((state) => state.pageNo);
  const isCurrent = pageNo?.target === PAGE_ID_MEMBER_MANAGER;

  useEffect(() => {
    if (isCurrent) {
      const params = {
        ...param,
        pageNo: pageNo?.no || 1,
        pageRows: pageNo?.pageRows,
      };

      mutation.mutate(params);
    }
  }, [pageNo?.no, pageNo?.pageRows]);

  return {
    rowData,
    pageNav: pageNavRef.current,
  };
};

// 매니저 상세
export const useGetData = () => {
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  const manInfRef = useRef<IManInf | null>(null);

  const mutation = useMutation({
    mutationKey: ["room-cancel-resv-detail"],
    mutationFn: manInfApi,
    onSuccess(res) {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          manInfRef.current = res.data;
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });

  useEffect(() => {
    if (listRowInf.no) {
      mutation.mutate(listRowInf.no);
    }
  }, [listRowInf.no]);

  return {
    manInf: manInfRef.current,
  };
};
